module.exports = __webpack_public_path__ + "static/media/colgate.d8ba076a.png";